<template>
  <div class="status-container">
    <div v-if="filteredStatuses.length > 0" class="status-list">
      <div class="items-container">
        <a 
          v-for="(status, index) in filteredStatuses" 
          :key="index" 
          href="#"
          class="status-item"
          @click.prevent="handleStatusClick(status)"
        >
          <span class="status-icon">•</span>
          <span class="status-text">
            {{ getDisplayNumber(status) }} - 
            {{ status.statusTypeName }}
            <small>({{ status.statusDateStr || formatDate(status.statusDate) }})</small>
          </span>
        </a>
      </div>
    </div>
    <div v-else class="no-statuses">
      <i class="fa-solid fa-circle-info"></i> Hazırkı status tapılmadı
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tasks',
  props: {
    statuses: {
      type: Array,
      default: () => [],
      validator: value => Array.isArray(value)
    }
  },
  computed: {
    filteredStatuses() {
      return [...this.statuses]
        .sort((a, b) => new Date(b.statusDate) - new Date(a.statusDate));
    }
  },
  methods: {
    getDisplayNumber(status) {
      return status.claimId ? 
        (status.dispClaimNumber || `Claim ${status.claimId}`) : 
        (status.dispAccidentNumber || `Accident ${status.accidentId}`);
    },
    formatDate(date) {
      if (!date) return '';
      const d = new Date(date);
      return d.toLocaleDateString('az-AZ');
    },
    handleStatusClick(status) {
      const roles = this.$store.state.user.roles;
      const isCallCenter = roles.includes('Call center operator');
      const isClientService = roles.includes('Client service operator');
      const isAccidentCommissar = roles.includes('Accident commissar operator');
      const isClientServiceManager = roles.includes('Client service manager');
      const isApprovalOperator = roles.includes('Approval operator');
      const isAdminOperator = roles.includes('Administrative operator');
      const isTechExpertManager = roles.includes('Tech expertise manager');
      const isTechExpert = roles.includes('Tech expertise operator');
      const isAssistantChairman = roles.includes('Assistant Chairman');
      const isDirectorICD = roles.includes('Director of ICD');
      const isManagerICAD = roles.includes('Manager of ICAD');
      const isPaymentOperator = roles.includes('Payment operator');
      const isPaymentManager = roles.includes('Payment manager');

      const routeData = this.$router.resolve({ 
        path: this.getRoutePath(status, {
          isCallCenter,
          isClientService,
          isAccidentCommissar,
          isClientServiceManager,
          isApprovalOperator,
          isAdminOperator,
          isTechExpertManager,
          isTechExpert,
          isAssistantChairman,
          isDirectorICD,
          isManagerICAD,
          isPaymentOperator,
          isPaymentManager
        })
      });
      window.open(routeData.href, '_blank');
    },
    getRoutePath(status, roles) {
      const { claimId, accidentId, statusTypeId } = status;
      
      if (roles.isCallCenter) return '/callcenter/main';
      if (roles.isAccidentCommissar && accidentId) return `/comm/accident/${accidentId}`;
      if (roles.isClientService) return claimId ? `/servicecenter/claim/${claimId}` : `/servicecenter/accident/${accidentId}`;
      if ((roles.isClientServiceManager || roles.isApprovalOperator || roles.isAdminOperator)) {
        if (statusTypeId === 30) return '/adm/responsible';
        return claimId ? `/servicecenter/claim/${claimId}` : `/servicecenter/accident/${accidentId}`;
      }
      if ((roles.isTechExpertManager || roles.isTechExpert) && claimId) return `/techexpert/claim/${claimId}`;
      if ((roles.isAssistantChairman || roles.isApprovalOperator || roles.isDirectorICD || roles.isManagerICAD) && claimId) {
        return `/approval/claim/${claimId}/${accidentId || ''}`;
      }
      if ((roles.isPaymentOperator || roles.isPaymentManager) && claimId) return `/payment/claim/${claimId}`;
      return claimId ? `/claim/${claimId}` : `/accident/${accidentId}`;
    }
  }
}
</script>

<style scoped>
.status-container {
  width: 100%;
  background: white;
  border-radius: 4px;
  overflow: hidden;
  height: 315px; /* Fixed height */
  display: flex;
  flex-direction: column;
}

.status-list {
  padding: 0;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.items-container {
  overflow-y: auto;
  flex: 1;
}

.status-item {
  display: flex;
  align-items: center;
  padding: 5px 12px;
  text-decoration: none;
  color: var(--color-primary); 
  border-bottom: 1px solid #f5f5f5;
  transition: background 0.2s;
}

.status-item:hover {
  background: #f9f9f9;
}

.status-icon {
  margin-right: 12px;
  font-size: 20px;
  color: #666;
}

.status-text {
  flex: 1;
  font-size: var(--font-large); 
}

.no-statuses {
  text-align: center;
  font-size: var(--font-large); 
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.no-statuses i {
  margin-right: 8px;
  color: #e94f44;
}
</style>